(function() { module.exports = window["Pinia"]; }());